import type { PathObjectInterface } from '@/map-phaser-new/interfaces'

export const cableCarRightToUpPath: PathObjectInterface = {
  mainPath: { x: 3469, y: 2100 },
  spline: [
    3469, 2068, 3436, 1929, 3364, 1720, 3311, 1528, 3246, 1348, 3196, 1209, 3112, 1055, 3026, 870,
    2973, 757, 2896, 549, 2836, 397, 2798, 265, 2754, 265, 2712, 239.5, 2568, 196.5, 2496, 180,
  ],
}
